import { render, staticRenderFns } from "./DehorningThirdPage.vue?vue&type=template&id=7ef40baa&scoped=true&"
import script from "./DehorningThirdPage.vue?vue&type=script&lang=js&"
export * from "./DehorningThirdPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef40baa",
  null
  
)

export default component.exports